import React, { useEffect } from "react";
import RelatedPosts from "../components/RelatedPosts";
import Tags from "../components/Tags";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlog } from "../features/blog/blogSlice";
import ActionButton from "../components/ActionButton";

export default function Post() {
  const dispatch = useDispatch();
  const { postId } = useParams() || {};
  const { blog, isLoading } = useSelector((state) => state.blog);
  const { title, description, image, tags } = blog || {};

  useEffect(() => {
    dispatch(fetchBlog(postId));
  }, [dispatch, postId]);

  return (
    <>
      <div className="container mt-8">
        <Link
          to="/"
          className="inline-block text-gray-600 home-btn"
          id="lws-goHome"
        >
          <i className="mr-2 fa-solid fa-house"></i>Go Home
        </Link>
      </div>
      <section className="post-page-container">
        {isLoading ? (
          "Loading..."
        ) : (
          <main className="post">
            <img
              src={image}
              alt="githum"
              className="w-full rounded-md"
              id="lws-megaThumb"
            />
            <div>
              <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
                {title}
              </h1>
              <Tags tags={tags} />
              <ActionButton blog={blog} />
              <div className="mt-6">
                <p>{description}</p>
              </div>
            </div>
          </main>
        )}
        <RelatedPosts post={blog} />
      </section>
    </>
  );
}
